export default "__VITE_ASSET__DMQO5ORv__"